import React from "react";
import server from "../src/api/server";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import TeamMembers from "../src/components/Home/TeamMembers";
import { Container } from "react-bootstrap";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";

const TeamMembersPage = ({
  teamMembersSection,
  breadBackground,
  metaDataSections,
}) => {
  const { formatMessage , locale } = useIntl();
  const teamMeta = metaDataSections?.find((item) => item?.slug === "teamMember");

  return (
    <>
      <NextSeo
        title={teamMeta?.name[locale] || formatMessage({ id: teamMeta?.slug })}
        description={teamMeta?.description[locale] || 
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="teamMembers-page">
        <BreadCrumb
          title={formatMessage({ id: "teamMembers" })}
          pageTitle={formatMessage({ id: "teamMembers" })}
          breadBackground={breadBackground}
        />

        <TeamMembers teamMembersSection={teamMembersSection} />
      </div>
    </>
  );
};

export default TeamMembersPage;

export const getStaticProps = async (ctx) => {
  try {
    const teamMembersResponse = await server.get("/pages/team-1/sections");
    const backgroundResponse = await server.get("/pages/backgrounds");
    const metaDataResponse = await server.get("/pages/metaData");
    const breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
      (sec) => sec?.slug === "breadcrumbs"
    )?.image;

    return {
      revalidate: 1,
      props: {
        teamMembersSection: teamMembersResponse?.data?.data?.sections,
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : "",
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};
